var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdfFileIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 2.86719C12.979 2.86719 11.6875 1.5835 11.6875 0H2.5C1.94772 0 1.5 0.447715 1.5 1V15C1.5 15.5523 1.94772 16 2.5 16H13.5625C14.1148 16 14.5625 15.5523 14.5625 15V2.86719Z",
    fill: "url(#paint0_linear_1120_127418)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34824 12C5.19997 12 5.05543 11.9523 4.91754 11.8594C4.5921 11.6393 4.55356 11.3453 4.56023 11.1896C4.57209 10.8838 4.73741 10.3959 5.99839 9.66583C6.22078 8.73391 6.36903 7.53027 6.38758 6.5022C5.70482 5.74427 5.41794 5.14443 5.51209 4.67093C5.54471 4.50648 5.65813 4.20616 6.04806 4.04726C6.28824 3.94794 6.54177 4.00753 6.7234 4.20377C6.82644 4.31419 7.13186 4.64312 7.14743 6.16613C7.83982 6.87798 8.84949 7.68201 9.73908 8.22939C10.0771 8.16345 10.3744 8.13008 10.6249 8.13008C11.625 8.13008 11.751 8.69972 11.7592 8.94522C11.7666 9.19468 11.6732 9.35278 11.5939 9.44176C11.5093 9.53472 11.3544 9.64516 11.0912 9.64516C10.7524 9.64516 10.2565 9.45767 9.6138 9.08664C8.68344 9.30433 7.54923 9.73812 6.64187 10.2235C6.31046 11.4184 5.88644 12 5.34824 12ZM6.92057 9.1502L6.90945 9.19312C7.47063 8.93173 8.07479 8.69576 8.65155 8.51303L8.58927 8.47647L8.64784 8.46377C8.12521 8.09434 7.60332 7.67564 7.14446 7.25695V7.31256L7.11332 7.27999C7.07033 7.91558 6.98952 8.56943 6.87906 9.17323L6.92057 9.1502Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 2.875C12.9747 2.875 11.6875 1.58782 11.6875 0Z",
    fill: "#EFA0A5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1120_127418",
    x1: 8.03125,
    y1: 0,
    x2: 8.03125,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E35A64"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdfFileIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdf-file-icon.24056ab7f96c61b337947078470e8b0f.svg";